<template>
    <div class="school-container">
        <van-swipe  :autoplay="3000" indicator-color="white" >
  <van-swipe-item v-for="item in sliders" :key="item.id" @click="clickSlider(item)">
      <img v-src="item.detail.sliderImg"  class="banner">
  </van-swipe-item>
</van-swipe>
        <div class="content">
            <h4>{{ title }}</h4>
            <router-link
                class="panel"
                :to="{ name: 'schoolSearch', params: { hId: item.id } }"
                v-for="item in hs"
                :key="item.id"
            >
                <div class="img-box">
                    <img :src="item.detail.img" />
                </div>
                <div class="text">
                    <div class="title">{{ item.name }}</div>
                    <div class="desc" v-html="item.detail.desc"></div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import { getDataHierarchies } from '@custouch/proxy-use'
export default {
    props: ['title', 'mId'],
    data() {
        return {
            hs: [],
            sliders:[]
        }
    },
    async created() {
        const data=await getDataHierarchies(this.mId)
            data.forEach(t=>{
                if(t.detail.img){
                    if(t.detail.sliderImg){
                           this.sliders.push(t)
                    }else{
                           this.hs.push(t)
                    }
                }
            })
        await this.$nextTick()
        anime
            .timeline({
                duration: 750,
                easing: 'spring(1, 80, 12, 0)',
                delay: anime.stagger(150)
            })
            .add({
                opacity: [0, 1],
                targets: ['.panel'],
                scale: [0, 1],
                translateY: [100, 0]
            })
    },
    methods:{
        clickSlider(item){
            this.$router.push({name:'schoolTopic',params:{hId:item.id}})
        }
    }
}
</script>

<style scoped lang="less">
.banner {
    width: 100%;
    height: 6.8rem;
    object-fit: contain;
}
.content {
    padding: 1rem;
    .panel {
        opacity: 0;
        width: 100%;
        height: 5.6rem;
        display: flex;
        margin-bottom: 1.2rem;
        .img-box {
            width: 5.95rem;
            border: 1px solid #014ca0;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 40%;
                object-fit: contain;
            }
        }
        .text {
            flex: 1;
            height: 100%;
            padding: 0.8rem 0.6rem;
            font-size: 0.6rem;
            color: #fff;
            background: @blue;
            .title {
                font-size: 0.7rem;
                font-weight: bold;
            }
        }
    }
}
</style>
